import { useMemo } from 'react';

import { useFetchFeaturesProvider } from './providers/fetchProvider';
import { useRelatedFeaturesProvider } from './providers/relatedProvider';
import {FEATURE_PICKER_TYPE} from "../../../constants";

const useDerivedPickerState = ({ featurePicker, groheFiltersSearchText }) => {
  const expanded = Boolean(featurePicker?.isOpen);

  const partIds = useMemo(() => featurePicker?.partIds || [], [featurePicker]);
  const searchText = useMemo(
    () => (expanded ? groheFiltersSearchText : ''),
    [expanded, groheFiltersSearchText]
  );

  const isShapePicker = featurePicker?.type === FEATURE_PICKER_TYPE.shape;

  return { expanded, partIds, searchText, isShapePicker };
};

export const useSqftFeaturePickerRows = ({
                                           featurePicker,
                                           groheFiltersSearchText,
                                           selectedFilters,
                                         }) => {
  const { expanded, partIds, searchText, isShapePicker } = useDerivedPickerState({
    featurePicker,
    groheFiltersSearchText,
  });

  const fetchResult = useFetchFeaturesProvider({
    enabled: expanded && !isShapePicker,
    partIds,
    searchText,
    selectedFilters,
  });

  const relatedResult = useRelatedFeaturesProvider({
    enabled: expanded && isShapePicker,
    featurePicker,
    fallbackPartId: partIds[0],
    searchText,
    selectedFilters,
  });

  return isShapePicker ? relatedResult : fetchResult;
};
